module.exports = __webpack_public_path__ + "static/images/icon-arrow-left.b9b83810185cf3bba02d86b4a268f4ba.svg";